import React, { ReactNode } from 'react';
import styles from './assets/provider-list-screen.module.scss';
import classNames from 'classnames';
import ProvidersGrid from './components/ProvidersGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import AdminLayout from 'src/components/layout/RoleLayout';
import { IProvider } from 'src/types/provider';
import Loader from '../../../../../../components/Loader';
import { useCookies } from 'react-cookie';

export interface StateProps {
    data: Paginated<Partial<IProvider>>;
    inProgress: boolean;
    inProgressCSV: boolean;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getDataCsv: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class ProviderAnalyticsListScreen extends React.Component<Props> {
    componentDidMount() {


    }

    public render(): ReactNode {
        const { data, getData, inProgress, inProgressCSV } = this.props;

        return (
            <AdminLayout>
                <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                    <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>
                        CONVERSION METRICS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                    </h2>
                </div>
                {inProgress ? <Loader /> : null}
                <div className={classNames(styles.list)}>
                    <ProvidersGrid
                        data={data}
                        getData={getData}
                        getDataCsv={this.props.getDataCsv}
                        inProgressCSV={inProgressCSV}
                    />
                </div>
            </AdminLayout>
        );
    }
}

export default ProviderAnalyticsListScreen;
